<template>
    <div id="coupons-page">
        <loader v-if="is('loading')"></loader>
        <div class="container-fluid" v-if="!is('loading')">
            <div class="row">
                <div class="col-md-12">
                    <div class="clearfix">
                        <span
                            class="alert alert-info"
                            v-if="is('empty')"
                            style="margin-bottom: 10px; display: inline-block"
                        >
                            {{ t("coupons-empty_prefix") }}
                            <strong> {{ t("coupons-empty_cta") }} </strong>
                        </span>
                        <button
                            class="btn btn-new btn-outline-success pull-right"
                            @click="addCoupon"
                            v-if="is('empty')"
                        >
                            {{ t("coupons-new_coupon") }}
                        </button>
                        <template v-if="!is('empty')">
                            <h2>{{ t("coupons-registered_coupons") }}</h2>

                            <div class="clear"></div>
                            <div class="coupons">
                                <coupon
                                    v-for="coupon in coupons"
                                    ref="coupons"
                                    :key="coupon.id"
                                    :disabled="is('saving')"
                                    :id="coupon.id"
                                    :text="coupon.text"
                                    :used="coupon.used"
                                    :generated="coupon.generated"
                                    :probability="parseInt(coupon.probability)"
                                    @change="updateTotalProbability"
                                    @focusProbability="totalProbabilityOn"
                                    @blurProbability="totalProbabilityOff"
                                ></coupon>
                            </div>

                            <div class="save" v-if="coupons.length">
                                <span
                                    class="alert alert-warning"
                                    v-if="totalProbability !== 100"
                                    >{{
                                        t("coupons-total_probability_error", {
                                            0: totalProbability,
                                        })
                                    }}</span
                                >
                                <span
                                    class="alert alert-success"
                                    v-if="showSuccess"
                                    >{{ t("coupons-saved_success") }}</span
                                >
                                <span
                                    class="total-probability"
                                    v-bind:class="{
                                        active: showTotalProbability,
                                        bad: totalProbability !== 100,
                                        good: totalProbability === 100,
                                    }"
                                >
                                    {{ totalProbability }}%</span
                                >
                                <div class="clear"></div>

                                <div class="clear"></div>

                                <button
                                    class="btn btn-new btn-outline-success pull-right"
                                    @click="addCoupon"
                                >
                                    {{ t("coupons-new_coupon") }}
                                </button>
                                <button
                                    class="btn pull-right"
                                    v-bind:class="{
                                        'btn-success': totalProbability === 100,
                                    }"
                                    :disabled="
                                        totalProbability !== 100 || is('saving')
                                    "
                                    @click="save"
                                >
                                    <span
                                        class="far fa-spin fa-spinner"
                                        v-if="is('saving')"
                                    ></span>
                                    {{ t("coupons-save_button") }}
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi";
import coupon from "./coupon.vue";
export default {
    components: {
        coupon: coupon,
    },
    data: function () {
        return {
            coupons: [],
            textNewCoupon: "",
            totalProbability: 0,
            state: "loading",
            showSuccess: false,
            showTotalProbability: false,
            probabilityTimeout: null,
        };
    },
    created: function () {
        document.getElementsByTagName("title")[0].innerText = this.t(
            "coupons-page_title",
        );
        this.updateList();
    },
    methods: {
        is: function (state) {
            return this.state === state;
        },
        setState: function (state) {
            this.state = state;
        },
        totalProbabilityOn: function () {
            window.clearTimeout(this.probabilityTimeout);
            this.showTotalProbability = true;
        },
        totalProbabilityOff: function () {
            var _self = this;
            this.probabilityTimeout = window.setTimeout(function () {
                _self.showTotalProbability = false;
            }, 2000);
        },
        save: function () {
            this.state = "saving";
            if (this.totalProbability === 100) {
                window.mixpanel?.track("Coupons - save begin");
                let bulkData = [];
                let removedCoupons = [];
                for (let c in this.$refs.coupons) {
                    let coupon = this.$refs.coupons[c];
                    if (!coupon.removed) {
                        let couponData = coupon.getData();
                        couponData.id = coupon.id;
                        bulkData.push(couponData);
                    } else {
                        removedCoupons.push(coupon.id);
                    }
                }
                var options = keviApi.getOptions("coupons/bulk-save", "PUT", {
                    coupons: bulkData,
                    removedCoupons: removedCoupons,
                });
                this.$http(options).then(function (response) {
                    if (response.status === 200) {
                        var _self = this;
                        this.$store.dispatch(
                            "notification/success",
                            this.t("coupons-saved_success"),
                        );
                        this.coupons = response.body;

                        window.mixpanel?.track("Coupons - save success");
                        this.setState("list");
                    }
                });
            }
        },
        updateList: function () {
            this.setState("loading");
            var options = keviApi.getOptions("coupons");
            this.$http(options).then(function (response) {
                if (response.status === 200 && response.body.length) {
                    this.coupons = response.body;
                    this.setState("list");
                } else {
                    this.setState("empty");
                }
            });
        },
        updateTotalProbability: function () {
            let totalProbability = 0;
            for (let c in this.$refs.coupons) {
                if (!this.$refs.coupons[c].removed) {
                    let couponProbability = parseInt(
                        this.$refs.coupons[c].probabilityField,
                    );
                    if (couponProbability) {
                        totalProbability = totalProbability + couponProbability;
                    }
                }
            }
            this.showSuccess = false;
            this.totalProbability = totalProbability;
        },
        addCoupon: function () {
            let newCoupon = {
                text: "",
                probability: 0,
                status: "new",
                used: 0,
                generated: 0,
            };
            this.coupons.push(newCoupon);
            window.mixpanel?.track("Coupons - add");
            this.textNewCoupon = "";
        },
    },
    watch: {
        coupons: function () {
            if (this.coupons.length) {
                this.setState("list");
            } else {
                this.setState("empty");
            }
        },
    },
};
</script>
